import Container from '@mui/material/Container';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import { useAuthContext } from 'src/auth/hooks';
import RestaurantAccountGeneral from '../restaurant-account-general';


export default function RestaurantProfilePageView() {
  const {user} = useAuthContext();

  if (!user?.restaurants[0].id) {
    return <div>No restaurant found</div>;
  }

  return (
    <PermissionBasedGuard hasContent permissions={['partners:read:restaurants']} sx={{ py: 10 }}>
      <Container maxWidth={false}>
          <RestaurantAccountGeneral id={user?.restaurants[0].id.toString()} />
      </Container>
    </PermissionBasedGuard>
  );
}
